/** Format montant Ariary pour affichage tarification. */
export function formatActPrice(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 0 })} Ar`;
}

/** Montant facture style FR : 10 000,00 */
export function formatInvoiceAmount(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export const PRICING_FILTER_OPTIONS = [
  { id: 'all', label: 'Tous' },
  { id: 'priced', label: 'Tarifés' },
  { id: 'unpriced', label: 'Non tarifés' }
];

export const COVERAGE_FILTER_OPTIONS = [
  { id: '', label: 'SMIE & CMC' },
  { id: 'SMIE', label: 'SMIE' },
  { id: 'CMC', label: 'CMC' }
];

export const EXAM_CATEGORY_TABS = [
  { id: 'ANALYSIS', label: 'Analyses' },
  { id: 'RADIOGRAPHY', label: 'Radiographies' },
  { id: 'ULTRASOUND', label: 'Échographies' }
];

export const REFERRAL_CATEGORY_TABS = [
  { id: '', label: 'Toutes' },
  { id: 'HOSPITAL_REFERRAL', label: 'Hôpital' },
  { id: 'OPHTHALMOLOGY', label: 'Ophtalmologie' },
  { id: 'PEDIATRICS', label: 'Pédiatrie' },
  { id: 'OPTICAL', label: 'Lunettes' }
];

export const ACT_PRICING_TABS = [
  { id: 'consultations', label: 'Consultations', icon: 'stethoscope' },
  { id: 'exams', label: 'Examens', icon: 'clipboard-list' },
  { id: 'referrals', label: 'Prise en charge', icon: 'heart' },
  { id: 'nursing-care', label: 'Soins infirmerie', icon: 'user-md' },
  { id: 'nursing-injections', label: 'Injections', icon: 'pills' },
  { id: 'nursing-tests', label: 'Tests infirmerie', icon: 'list' },
  { id: 'vaccines', label: 'Vaccins', icon: 'shield' },
  { id: 'family-planning', label: 'Planning familial', icon: 'users' }
];
